import api from '../../services/api';
import { useState, useEffect } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';
import EntityCardGrid from '../../common/components/EntityCardGrid';
import EntityCard from '../../common/components/EntityCard';
import usePermissoes from '../../common/hooks/usePermissoes';
import Permissoes from '../../common/permissoes';

function Mercadoria() {
    const { hasPermission } = usePermissoes();
    const [textoPesquisa, setTextoPesquisa] = useState("");
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/mercadoria/pesquisa?texto=${textoPesquisa}&page=${page - 1}`);
                setData(response.data.content);
                setTotalPages(response.data.page.totalPages);
            } catch (error) {
                console.error("Erro ao buscar dados das mercadorias:", error);
            }
        }
        fetchData();
    }, [page, textoPesquisa]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    return (
        <PageContainer>
            <PageHeader
                title="Mercadoria"
                searchValue={textoPesquisa}
                onSearchChange={(e) => {
                    setPage(1);
                    setTextoPesquisa(e.target.value);
                }}
                actionLabel={hasPermission(Permissoes.MERCADORIA_CADASTRO) ? "Adicionar Item" : undefined}
                actionIcon={<AddCircleOutlineIcon />}
                actionTo="/mercadoria/cadastro"
            />

            <EntityCardGrid
                items={data}
                keyExtractor={(mercadoria) => mercadoria.id}
                emptyMessage="Nenhuma mercadoria encontrada."
                renderItem={(mercadoria) => (
                    <EntityCard
                        to={`/mercadoria/${mercadoria.id}`}
                        image={mercadoria.foto ? `data:image/jpeg;base64,${mercadoria.foto}` : null}
                        icon={<Inventory2OutlinedIcon fontSize="inherit" />}
                        title={mercadoria.nome}
                        subtitle={`Qtd: ${mercadoria.estoque} ${mercadoria.unidMedida || ''}`}
                    />
                )}
            />

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
                </Box>
            )}
        </PageContainer>
    );
}

export default Mercadoria;
